import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { svgs } from 'design-system';
import { sinpePayment, bankTransferPayment } from 'src/constants/paymentTypes';

export const creditCardInstructions = (
  <Grid container alignItems="center">
    <Typography color="secondary" variant="caption" style={{ fontSize: 12 }}>
      Aceptamos
    </Typography>
    &nbsp;&nbsp;
    <img src={svgs.mastercard} alt="mastercard" />
    &nbsp;&nbsp;
    <img src={svgs.visa} alt="visa" />
    &nbsp;&nbsp;
    <img src={svgs.amex} alt="amex" />
  </Grid>
);

type InstructionProps = {
  paymentType: string;
  moneyType?: string;
};

export const BankTransferInstructions = ({
  paymentType,
  moneyType,
}: InstructionProps): JSX.Element => {
  if (paymentType !== bankTransferPayment) {
    return <></>;
  }

  return (
    <Grid data-testid="bank-transfer-instruction">
      <Typography color="secondary" variant="caption" style={{ fontSize: 12 }}>
        Realiza la transferencia y adjunta el comprobante para emitir la póliza.
        <br />
      </Typography>
      <Typography style={{ lineHeight: '6px' }}>&nbsp;</Typography>
      <Typography
        color="primary"
        variant="caption"
        style={{ fontSize: 15, fontWeight: 700 }}
      >
        Número de cuenta - {moneyType === '$' ? 'DÓLARES' : 'COLONES'}
        <br />
      </Typography>
      <Typography
        color="primary"
        variant="caption"
        style={{ fontSize: 15, fontWeight: 700 }}
      >
        {moneyType === '$'
          ? 'CR 8001 0200 0091 0088 2365'
          : 'CR 3401 0200 0091 0088 2514'}
      </Typography>
    </Grid>
  );
};

export const SinpePaymentInstructions = ({
  paymentType,
}: InstructionProps): JSX.Element => {
  if (paymentType !== sinpePayment) {
    return <></>;
  }

  return (
    <Grid data-testid="sinpe-instruction">
      <Typography color="secondary" variant="caption" style={{ fontSize: 12 }}>
        Realiza la transferencia desde tu celular y adjunta el comprobante para
        emitir la póliza.
        <br />
      </Typography>
      <Typography style={{ lineHeight: '6px' }}>&nbsp;</Typography>
      <Typography
        color="primary"
        variant="caption"
        style={{ fontSize: 15, fontWeight: 700 }}
      >
        Número SINPE (Colones)
        <br />
      </Typography>
      <Typography
        color="primary"
        variant="caption"
        style={{ fontSize: 15, fontWeight: 700 }}
      >
        8634 - 9301
        <br />
      </Typography>
      <Typography color="primary" variant="caption" style={{ fontSize: 15 }}>
        A nombre de: ASSA Compañía de Seguros
      </Typography>
    </Grid>
  );
};

export const yappyPaymentInstructions =
  'Ten a mano tu celular y paga en línea por medio de Yappy de Banco General.';
export const brokerPaymentInstructions =
  'Al emitir bajo este método de pago deberás pagarle directamente a tu corredor. Tu corredor será quien te entregue la póliza.';
export const cashPaymentInstructions =
  'El cliente debe realizar el pago en caja en cualquiera de las sucursales.';
export const achPaymentInstructions =
  'El cliente deberá completar el formulario de ACH y hacer el pago de la primera cuota.';
export const disclaimerHasMonthlyPayment =
  'El cobro de la primera cuota se hará efectivo el día de hoy.';
export const disclaimerHasFreeMonth =
  'Para activar tu póliza,  debes tener un saldo disponible  mínimo de $1 (un dólar) en tu tarjeta de crédito.';
export const disclaimerHasCardTypeAmex = `El cobro de la primera cuota se hará efectivo al día siguiente.`;
export const INFO_ICON_SIZE = 24;
export const collaborator = 'ASE';
export const discleimerAnnualMessage = `El cobro de la anualidad se hará efectivo el día de hoy.`;
export const discleimerAmexAnnualMessage = `El cobro de la anualidad se hará efectivo al día siguiente.`;
